import logo from '../images/wistor-mark-color.svg'
import styles from './AnimatedWistorLogo.module.css'

export function AnimatedWistorLogo() {

  return (
    <div className={styles['loading-wrapper']} role="status" aria-label="Loading Wistor...">
        <img className={styles['loading-top']} src={logo} />
        <img className={styles['loading-bottom']} src={logo} />
    </div>
  )
}